export default __webpack_public_path__ + "static/media/family-icon.ff52876a.png";